<template>
  <div class="works-roots">
    我的作品
  </div>
</template>

<script>
export default {
  name: 'Works',

  mounted () {
  },

  methods: {
  }
}
</script>

<style lang="stylus">
  .works-roots
    width 100%
    height 100%
    text-align center
    color #fff
</style>



// WEBPACK FOOTER //
// index.vue?320e05ca